var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUssd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 124.6 124.6",
    style: {
      enableBackground: "new 0 0 124.6 124.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "85.2,57.9 95.2,57.9 93.4,66.4 83.4,66.4  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3,2.4C29.2,2.4,2.4,29.2,2.4,62.3c0,33.1,26.8,59.9,59.9,59.9c33.1,0,59.9-26.8,59.9-59.9 C122.3,29.2,95.4,2.4,62.3,2.4z M54.6,67.4l-5.6,10l-11.6-9.6l2.5,14.9H28.6L31,67.8l-11.5,9.8l-5.9-10.3l14-5.1l-13.9-4.9l5.5-9.9 l12,9.5l-2.5-15h11.3l-2.6,15l11.9-9.4l5.4,9.7l-14,5.1L54.6,67.4z M107.7,66.4v6.9h-8.5l-2,9.4H90l2-9.4h-10l-2,9.4h-7.3l2-9.4 h-8.3v-6.9h9.8l1.8-8.5h-8.3V51h9.7l1.9-9.1h7.3L86.7,51h10l1.9-9.1h7.3l-1.9,9.1h7v6.9h-8.5l-1.8,8.5H107.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUssd);
export default __webpack_public_path__ + "static/media/ussd.e60e7721.svg";
export { ForwardRef as ReactComponent };